import Button from '@r1-frontend/ui-react/components/buttons/button';
import { Cost } from '@r1-frontend/ui-react/components/costs';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { Paragraph5 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { NBSP } from '@r1-frontend/ui-react/tokens/symbols';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import { ControlsWithQuantity } from '~/src/features/full-buy/components/EquipmentControls/ControlsWithQuantity';

import * as ST from './styled';


interface IProps {
    cost: number,
    quantity: number,
    text: string,
    onIncrement: () => void,
    onDecrement: () => void,
    onAddClick: () => void,
    onClose: () => void,
    minQuantity?: number,
    disabled?: boolean,
    isMonthly?: boolean,
}

export const EquipmentControls = ({
    cost,
    quantity,
    minQuantity = 0,
    disabled = false,
    onIncrement,
    onDecrement,
    onAddClick,
    onClose,
    text,
    isMonthly,
}: IProps) => {
    const isMobile = useMatchMedia(`(max-width: ${wideBreakpoints.mobile})`);

    return <ST.EquipmentControlsComponent
        $direction={'row'}
        $wrap={isMobile ? 'wrap' : 'nowrap'}
        $size={12}
    >
        {quantity
            ? <ControlsWithQuantity
                quantity={quantity}
                minQuantity={minQuantity}
                disabled={disabled}
                onIncrement={onIncrement}
                onDecrement={onDecrement}
                onClose={onClose}
            />
            : <Button
                data-bType='accent'
                bType={'accent'}
                size={'medium'}
                onClick={onAddClick}
            >
                Добавить
            </Button>
        }
        <Paragraph5 $color={COLORS.TextSecondary}>
            {text}{NBSP}
            <Cost isMonthly={isMonthly}>{cost}</Cost>
        </Paragraph5>
    </ST.EquipmentControlsComponent>;
};
